<template>
  <div class="filter-tabs" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      role="tab"
      :aria-selected="value === tab.id"
      class="tab"
      :class="{ active: value === tab.id }"
      :style="value === tab.id ? activeStyle : null"
      @click="$emit('input', tab.id)"
    >
      {{ tab.label }}
      <span v-if="tab.id === 'all' && totalLearningObjects" class="tab-count">· {{ totalLearningObjects }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'MyDownloadsFilterTabs',
  props: {
    value: { type: String, default: 'all' },
    totalLearningObjects: { type: Number, default: 0 }
  },
  data() {
    return {
      tabs: [
        { id: 'all', label: 'Tudo' },
        { id: 'inProgress', label: 'Em andamento' },
        { id: 'completed', label: 'Concluídas' }
      ]
    };
  },
  computed: {
    activeStyle() {
      return {
        backgroundColor: this.$theme.primaryColor,
        color: this.$theme.primaryText,
        borderColor: 'transparent'
      };
    }
  }
};
</script>

<style scoped lang="scss">
.filter-tabs {
  display: flex;
  gap: 8px;
  padding: 6px 18px 14px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar { display: none; }
}

.tab {
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 999px;
  background: transparent;
  border: 0.5px solid var(--md-border-strong);
  color: var(--md-text-dim);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;

  &.active {
    font-weight: 600;
  }
}

.tab-count {
  margin-left: 4px;
  opacity: 0.85;
}
</style>
